import { render, staticRenderFns } from "./Multipane.vue?vue&type=template&id=1b80a1a5&"
import script from "./Multipane.ts?vue&type=script&lang=ts&"
export * from "./Multipane.ts?vue&type=script&lang=ts&"
import style0 from "./Multipane.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Multipane.vue"
export default component.exports